import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/shared-module/seguridad/services/auth.guard';
import { DownloadFileComponent } from './views/download-file/download-file.component';
import { ExportCsvComponent } from './views/export-csv/export-csv.component';
import { HomeDistribuidorComponent } from './views/home-distribuidor/home-distribuidor.component';
import { MantenedorDistribuidorComponent } from './views/mantenedor-distribuidor/mantenedor-distribuidor.component';
import { ReportePresupuestoSellInComponent } from './views/reporte-presupuesto-sell-in/reporte-presupuesto-sell-in.component';
import { ReportePresupuestoComponent } from './views/reporte-presupuesto/reporte-presupuesto.component';
import { UploadCsvDisComponent } from './views/upload-csv-dis/upload-csv-dis.component';
import { UploadCsvPresupuestoComponent } from './views/upload-csv-presupuesto/upload-csv-presupuesto.component';
import { UploadCsvRutaComponent } from './views/upload-csv-ruta/upload-csv-ruta.component';
import { UploadCsvSellinComponent } from './views/upload-csv-sellin/upload-csv-sellin.component';


const distribuidorRoutes: Routes = [
  { path: 'distribuidor/home', component: HomeDistribuidorComponent}, //, canActivate: [AuthGuard]},
  { path: 'distribuidor/upload-csv-dis', component: UploadCsvDisComponent},// canActivate: [AuthGuard]},
  { path: 'distribuidor/upload-csv-presupuesto', component: UploadCsvPresupuestoComponent}, //, canActivate: [AuthGuard]},
  { path: 'distribuidor/upload-csv-ruta', component: UploadCsvRutaComponent}, //, canActivate: [AuthGuard]},
  { path: 'distribuidor/download-csv-file', component: DownloadFileComponent}, //, canActivate: [AuthGuard]},
  { path: 'distribuidor/mantenedor-distribuidor', component: MantenedorDistribuidorComponent}, //, canActivate: [AuthGuard]},
  { path: 'distribuidor/reporte-presupuesto', component: ReportePresupuestoComponent}, //, canActivate: [AuthGuard]},
  { path: 'distribuidor/reporte-presupuesto-sellIn', component: ReportePresupuestoSellInComponent}, //, canActivate: [AuthGuard]},
  { path: 'distribuidor/upload-csv-sellin', component: UploadCsvSellinComponent}, //, canActivate: [AuthGuard]},
  //solo desarrollo
  { path: 'distribuidor/export-csv', component: ExportCsvComponent}, //, canActivate: [AuthGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(distribuidorRoutes)],
  exports: [RouterModule]
})
export class DistribuidorRoutingModule {}
